import { AbstractControl, ValidatorFn } from "@angular/forms";

export class MismatchValidator {

  static mismatch(forComparisonControl: AbstractControl | null): ValidatorFn {
    return (inputControl: AbstractControl): { [key: string]: boolean } | null => {
      if (!forComparisonControl)
        return null;

      let value = inputControl.value;
      if (value && value.trim() != "" && value !== forComparisonControl.value) {
        return { 'mismatch': true };
      }

      return null;
    };
  }
}
